import ApiHelper from "../../helper/ApiHelper";

class InvitationApis {

    fetchCompanyData(companyId,params, token) {
        return ApiHelper.get(`/admin/api/v1/company/${companyId}`, {...params}, {token: token},false);
    }
    uploadCompanyLogo(companyId,params, token) {
        return ApiHelper.multipartFormPost(`/admin/api/v1/company/${companyId}/logo`, params, {},{token: token},false);
    }
    updateCompanyData(companyId,params, token) {
        return ApiHelper.put(`/admin/api/v1/company/${companyId}`, {...params}, {},{token: token},false);
    }
    fetchCountryList(params,token){
        return ApiHelper.get(`/admin/api/v1/country`, {...params}, {token: token},false);
    }
    fetchRegionList(params,token){
        return ApiHelper.get(`/admin/api/v1/region`, {...params}, {token: token},false);
    }
    fetchTimeZone(params,token){
        return ApiHelper.get(`/admin/api/v1/timezone`, {...params}, {token: token},false, {cacheTTL: 24 * 60 * 60 * 1000});
    }
    addCompanyData(companyId,params, token) {
        return ApiHelper.post(`/admin/api/v1/company`, params, {},{token: token},false);
    }

}

const serviceInstance = new InvitationApis();
Object.freeze(serviceInstance);
export default serviceInstance;